
//import liraries
import React, { Component, useState, useEffect } from 'react';
import { View, Text, ImageBackground, Image, TouchableOpacity, ScrollView, FlatList, Dimensions } from 'react-native';
import CButton from '../../common/CButton';
import CHeader from '../../common/CHeader';
import CImage from '../../common/CImage';
import CText from '../../common/CText';
import CView from '../../common/CView';
import { COLORS, FONTS } from '../../constant';
import { getOptIn, getAllVehiclesListMPEnabled } from "../../api/maxProApi";
import * as RootNavigation from "../../utilities/RootNavigation";
import { get, isEmpty } from "lodash";
import MPHomeBannerPic from "../../assets/images/maxpro/mp_home_banner.png";
import MPHomeHeaderPic from "../../assets/images/maxpro/mp_home_header.png";
import ModalAlert from '../../common/ModalAlert';
import Loader from '../../common/Loader';
import useStyles from './MPHome_Styels';
import CDocxViewer from '../../common/CDocxViewer';

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;


// create a component
const MPHome = (props) => {
    const styles = useStyles();
    const [loading, setLoading] = useState(false);
    const [targetVrn, setTargetVrn] = useState("");
    const [mPvehicleList, setMPVehicleList] = useState([]);
    const [tncModalVisible, setTncModalVisible] = useState(false);
    const [alertModalVisible, setAlertModalVisible] = useState(false);
    const [optOutSuccess, setOptOutSuccess] = useState(false);
    const [alertModal, setAlertModal] = useState({
        title: "",
        status: "",
        message: "",
        navigateScreen: "",
        actionButton: "",
    });
    const onCloseModal = () => {
        setAlertModalVisible(false);
        if (optOutSuccess == true) {
            RootNavigation.navigate("Home", {
                screen: "Home",
                params: { screen: "" },
            })
        }
    };

    const getMPEnabledVehicles = () => {
        setLoading(true);
        getAllVehiclesListMPEnabled()
            .then((res) => {
                console.log("MPEnabled Veh Res1: ", res);
                if (res && !isEmpty(res)) {
                    setMPVehicleList(res);
                    setLoading(false)
                }
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setAlertModal({
                    title: "Error",
                    status: "error",
                    message: err.message,
                    navigateScreen: "",
                    actionButton: "OK",
                });
                setAlertModalVisible(true);
                setLoading(false)
                console.log("<------------ error in MPEnabled Veh ----------->");
            });
    };
    const vehicleSelelctionForCredit = (params) => {
        setTargetVrn(params.toVrn);
    };
    useEffect(() => {
        getMPEnabledVehicles()
        if((global.optIn === true && global.navFromDB === true && !global.navFromOS) || (global.optIn === true && global.navFromVD === true && !global.navFromOS)){
            
            props.setActiveScreen("benefits")
          } else if((global.optIn === false && global.navFromDB === true && global.navFromOS == false) || (global.optIn === false && global.navFromVD === true && !global.navFromOS )){
            
            props.setActiveScreen("home")
          }
        { console.log(props?.setBasicData, global.selectedVehForMP, 'setBasicData') }
    }, [global.optIn,global.navFromDB,global.navFromVD,global.navFromOS]);
    const onClickMPOptIn = () => {
        setLoading(true)
        let param = {
            customerId: "",
            vrn: global.navFromVD == true ? global.selectedVrnFromVDForMP : global.selectedVehForMP?.vrn,
            tagId: selectedVrnFromVDForMPTagId,
            requestType: "OPT-IN",
        }
        console.log(param, 'MP opt In req obj')
        getOptIn(param).then(res => {
            setLoading(false)
            if (res?.statusCode == 200 || res?.statusCode == 1102) {
                console.log(res?.data, "MP opt In response")
                setAlertModal({
                    title: "Successful",
                    status: "success",
                    message: res.message,
                    navigateScreen: "",
                    actionButton: "OK",
                });
                setAlertModalVisible(true);
                setOptOutSuccess(true)

            } else if (res?.statusCode < 0 || res?.statusCode == 500 || res?.statusCode == -1102) {
                setAlertModal({
                    title: "Error",
                    status: "error",
                    message: res.message,
                    navigateScreen: "",
                    actionButton: "OK",
                });
                setAlertModalVisible(true);
                setLoading(false)
            }

        }).catch(err => {
            setAlertModal({
                title: "Error",
                status: "error",
                message: res.message,
                navigateScreen: "",
                actionButton: "OK",
            });
            setAlertModalVisible(true);
            setLoading(false)
        })
    }

    const benefitsData = [{
        text: "Emergency Breakdown Service - \n Reliable help when you need it",
        icon: <CImage.MPListIcon1 />
    }, {
        text: "Get your PUC Bill reimbursed upto ₹200",
        icon: <CImage.MPListIcon2 />
    }, {
        text: "Fuel Delivery: Complimentary fuel delivery services upto ₹500",
        icon: <CImage.MPListIcon3 />
    }, {
        text: "Complimentary vehicle pickup service up to 50 kms to the workshop",
        icon: <CImage.MPListIcon4 />
    }, {
        text: "Forget the hassles of Minimum Balance & Security Deposit (Zero minimum balance)",
        icon: <CImage.MPListIcon5 />
    }]

    return (
        <View style={styles.container}>
            {loading && <Loader />}
            <View style={styles.backNavWidget}>
                <CHeader showBack onPress={() => {
                    RootNavigation.navigate("Home", { screen: "Home", })}} 
                    title={"Back"} />
            </View>
            <View style={styles.headerImgWidget}>
                <Image style={styles.mPHomeHeaderPicStyle} source={MPHomeHeaderPic} />
            </View>
            {console.log(mPvehicleList, global.navFromDB, global.optIn, 'MPvehicleList')}
            {mPvehicleList && mPvehicleList?.length > 0 && global.optIn == true ?
                <View style={styles.contentWrapper}>
                    <View style={styles.availBenfitBtn}>
                        {console.log(targetVrn,'targetVrn2')}
                    <CButton 
                        isDisabled={targetVrn == ""}
                         onPress={() => {
                                global.selectedVehicleForMax = targetVrn?.vrn
                                global.mpExipryDate = targetVrn?.maxProExpiryDate
                                props.setActiveScreen("benefits")
                            }}
                            title={'View & Avail Benefits'} />
                    </View>
                    <View style={styles.bannerContainer}>
                        <ImageBackground source={MPHomeBannerPic} resizeMode="cover" style={styles.bgImageMax}>
                            <View style={styles.bannerTextWidgetMax}>
                                 <CImage.MpShieldBlueHomeIconPNG></CImage.MpShieldBlueHomeIconPNG>
                                <View style={styles.bannerInnerTextWidgetMax}>
                                    <CText.mpTitleText>{"Covered "}</CText.mpTitleText>
                                    <CView FR>
                                        <CText.mpTitleText>{"by"}</CText.mpTitleText>
                                        <CText.mpTitleTextYellow>{"MAX"}</CText.mpTitleTextYellow>
                                    </CView>
                                </View>
                                <View style={styles.bannerDescWidget}>
                                    <CText.fundTransferTextDesc>
                                        {"Dear user, you already have FASTag MAX active. Please select a vehicle to view and avail benefits."}
                                    </CText.fundTransferTextDesc>
                                </View>
                            </View>
                        </ImageBackground>
                    </View>
                    <View style={styles.benefitContainerMax}>
                        <Text style={styles.benefitTextHeader}>{"Please select a Tag for availing FASTag MAX benefits"}</Text>
                        <ScrollView  >
                            <FlatList
                                extraData
                                style={styles.flatListStyle}
                                data={isEmpty(mPvehicleList) ? [] : mPvehicleList}
                                key={mPvehicleList.length}
                                renderItem={({ item }) => {
                                    return (
                                        <View style={styles.cardViewStyle}>
                                            <CImage.CarImg></CImage.CarImg>
                                            <CView style={{paddingLeft:20}}>
                                                <View style={[styles.vehicleViewStyle,]}>
                                                    <CText.vrnText style={{marginBottom:4}}> {get(item, "vrn", "")}</CText.vrnText>
                                                    <CText.vehicleModal> {get(item, "fastagId", "")}</CText.vehicleModal>
                                                    <View>
                                                        {item.status && item.status != "Activated" && (
                                                            <View style={{ flexDirection: "row", alignItems: "center",}}>
                                                                <Image source={item.status == "Hotlisted by service provider" ? require("../../assets/images/hotlisted_icon.png") : item.status == "Low Balance" ? require("../../assets/images/lowbalance_icon.png") : item.status == "Blacklist" ? require("../../assets/images/blacklisted_icon.png") : null} style={{ height: 16, width: 16, top: 0 }} />
                                                                <Text style={[styles.lowBalanceText, { color: item.status == "Hotlisted by service provider" ? "#e9730d" : item.status == "Low Balance" ? "#ff0000" : item.status == "Blacklist" ? "#880000" : "" }]}>
                                                                    {item.status == "Hotlisted by service provider" ? "Hotlisted" : item.status == "Low Balance" ? "Low Balance" : item.status == "Blacklist" ? "Blacklisted" : ""}
                                                                </Text>
                                                            </View>
                                                        )}
                                                    </View>
                                                </View>
                                                <CView FR AC MT={10} ML={4}>
                                                    <CImage.IconToll></CImage.IconToll>
                                                    <CView style={{ marginLeft: 20 }}>
                                                        <CText.priceText>{"\u20B9  "} {get(item, "fastagBalance", "").toFixed(2)} </CText.priceText>
                                                        <CText.vehicleModal>{"FASTag Balance"}</CText.vehicleModal>
                                                    </CView>
                                                </CView>
                                            </CView>
                                            <TouchableOpacity
                                                onPress={() => { vehicleSelelctionForCredit({ toVrn: item }); }}
                                                style={styles.radiobuttonOutSideStyle}
                                            >
                                                {targetVrn?.vrn == item.vrn ? ( <CImage.TickActive></CImage.TickActive>) : null}
                                            </TouchableOpacity>
                                        </View>
                                    );
                                }}
                                keyExtractor={(item) => item.id}
                                numColumns={isSmallDevice ? null : isTabView ? 1 : 1}
                            />
                        </ScrollView>
                    </View>
                    <View style={styles.availBenfitBtnMobile}>
                    <CButton 
                        isDisabled={targetVrn == ""} 
                        onPress={() => {
                                global.selectedVehicleForMax = targetVrn?.vrn
                                global.mpExipryDate = targetVrn?.maxProExpiryDate
                                props.setActiveScreen("benefits")
                                }}
                            title={'View & Avail Benefits'} />
                    </View>
                </View>
                :
                <View style={styles.contentWrapper}>
                    <View style={styles.bannerContainer}>
                        <ImageBackground source={MPHomeBannerPic} resizeMode="cover" style={styles.bgImage}>
                            <View style={styles.bannerTextWidget}>
                                <CView>
                                    <CText.mpTitleText>{"Upgrade to"}</CText.mpTitleText>
                                    <CView FR>
                                        <CText.mpTitleText>{"unlock all"}</CText.mpTitleText>
                                        <CText.mpTitleTextYellow>{"MAX"}</CText.mpTitleTextYellow>
                                        <CText.mpTitleText>{"benefits"}</CText.mpTitleText>
                                    </CView>
                                </CView>
                                <CImage.MPHomeBadge></CImage.MPHomeBadge>
                            </View>
                            <View style={styles.memberShipWidget}>
                                <CText.mpTextYellow>{"Membership fees"}</CText.mpTextYellow>
                                <CText.mpYearText>{"\u20B9"}{`${global.maxProductValue} for 1 year`}</CText.mpYearText>
                                <View style={{ width: 210 }}>
                                    <CButton onPress={() => {
                                        global.navFromVD == true && global.navFromDB == false && global.optIn == false ?
                                            onClickMPOptIn()
                                            :
                                            props.setActiveScreen("selectMPVehicle")
                                         }}
                                        title={'Upgrade to MAX'} />
                                </View>
                                <View style={styles.termsTextWidgetLg}>
                                    <Text style={styles.termsText}>{"By clicking on ‘Upgrade to MAX’ I confirm to have read and agreed to the "}</Text>
                                    <TouchableOpacity onPress={() => setTncModalVisible(true)}>
                                        <CText.mpTermsText>{"terms & conditions"}</CText.mpTermsText>
                                    </TouchableOpacity>
                                </View>
                            </View>
                        </ImageBackground>
                    </View>
                    <View style={styles.benefitContainer}>
                        <CView FR AC MT={20} >
                            <CImage.MPHeaderLeftArrow></CImage.MPHeaderLeftArrow>
                            <CText.mpHeaderText>{"Upgrade benefits"}</CText.mpHeaderText>
                            <CImage.MPHeaderRightArrow></CImage.MPHeaderRightArrow>
                        </CView>
                        <View style={styles.benefitTextContainer}>
                            {benefitsData.map((item, index) => {
                                return (
                                <CView key={index} FR AC MT={14}>
                                    <Text >{item.icon}</Text>
                                    <CText.mpbenefitText style={{ marginLeft: "15px" }}>{item.text}</CText.mpbenefitText>
                                </CView>)
                            })}
                        </View>
                        <View style={styles.notificationWidget}>
                            <View style={styles.notificationCircle}>
                                <Text style={styles.notificationText}>{"i"}</Text> 
                            </View>
                            <CText.mpbenefitText>{"FASTag MAX membership will get auto-renewed until you opt-out"}</CText.mpbenefitText>
                        </View>
                    </View>
                    <View style={styles.memberShipWidgetMobile}>
                        <CText.mpTextYellow style={{ color: COLORS.green }}>{"Membership fees"}</CText.mpTextYellow>
                        <CText.mpYearText style={{ color: COLORS.black }}>{"\u20B9"}{`${global.maxProductValue} for 1 year`}</CText.mpYearText>
                        <View style={{ width: 210 }}>
                            <CButton onPress={() => {
                                global.navFromVD == true && global.navFromDB == false && global.optIn == false ?
                                    onClickMPOptIn()
                                    :
                                    props.setActiveScreen("selectMPVehicle")
                            }}
                                title={'Upgrade to MAX'} />
                        </View>
                        <View style={styles.termsTextWidget}>
                            <Text style={styles.termsText}>{"By clicking on ‘Upgrade to MAX’ I confirm to have read and agreed to the "}
                                <TouchableOpacity onPress={() => setTncModalVisible(true)}>
                                    <CText.mpTermsText style={{ color: COLORS.black }}>{"terms & conditions"}</CText.mpTermsText>
                                </TouchableOpacity>
                            </Text>
                        </View>
                    </View>
                </View>
            }

            {tncModalVisible && <CDocxViewer type = "FF_PROMAX_TNC" visibility={setTncModalVisible}/>}

            {alertModalVisible ? (
                <View style={styles.overlayViewStyle}>
                    <ModalAlert
                        title={alertModal.title}
                        status={alertModal.status}
                        message={alertModal.message}
                        navigateScreen={alertModal.navigateScreen}
                        actionButton={"OK"}
                        onCloseModal={onCloseModal}
                    />
                </View>
            ) : null}
            
        </View>
    );
};

//make this component available to the app
export default MPHome;

